import InputStyle from "./Input.module.scss";

interface Props {
  name: string;
  value: number | string;
  placeholder: string;
  specialClass: string;
  text: string;
  type: "number" | "text";
  min?: string | number,
  max?: string | number,
  step?: number,
  onChange: (name: string, value: number | string) => void;
  onBlur?: () => void;
}

const Input = ({
  value,
  placeholder,
  specialClass,
  name,
  type,
  text,
  min,
  max,
  step,
  onBlur,
  onChange,
}: Props): React.JSX.Element => {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = type === "number" ? Number(e.target.value) : e.target.value;

    if (type === "number") {
      if (min !== undefined && val < min) val = min;
      if (max !== undefined && val > max) val = max;
    }

    onChange(name, val);
  };

  return (
    <div className={InputStyle.wrapperInput}>
      <label htmlFor={name} className={InputStyle.label}>{text}</label>
      <input
        className={`${InputStyle.input} ${specialClass}`}
        value={value}
        id={name}
        name={name}
        min={min}
        max={max}
        step={step}
        placeholder={placeholder}
        type={type}
        onChange={handleChange}
        onBlur={() => onBlur && onBlur()}
      />
    </div>
  );
};

export default Input;
